import React, { Fragment } from "react";

const ReportInfoSection = ({
  rows,
  fontSizeOverride = null,
  titleWidthOverride = {
    col1: null,
    col2: null,
  },
  multiField = {
    // auto-calculate these values
    valWidthOverride: {
      col1: "125px",
      col2: "125px", // todo: add support for second column
    },
    gapWidth: {
      col1: "20px",
      col2: "20px", // todo: add support for second column
    },
  },
  centered = false,
}) => {
  let col1TitleInlineStyle = {};
  let col2TitleInlineStyle = {};
  if (titleWidthOverride && typeof titleWidthOverride === "object") {
    titleWidthOverride.col1 &&
      (col1TitleInlineStyle = { ...col1TitleInlineStyle, width: titleWidthOverride.col1, minWidth: titleWidthOverride.col1 });
    titleWidthOverride.col1 &&
      (col2TitleInlineStyle = { ...col2TitleInlineStyle, width: titleWidthOverride.col2, minWidth: titleWidthOverride.col2 });
  }
  return (
    <div style={fontSizeOverride ? { fontSize: fontSizeOverride } : {}}>
      {rows.map((row) => {
        return (
          <div className="report-header-flex-container">
            {centered ? <div className="spacer"></div> : null}
            <div className="report-header-property">
              {row.col1 && (
                <Fragment>
                  {row.col1.title2 ? (
                    // display two fields instead of one
                    <Fragment>
                      <label className="title" style={col1TitleInlineStyle}>{`${row.col1.title}:`}</label>
                      <div className="value" style={{ minWidth: multiField.valWidthOverride.col1 }}>
                        {row.col1.value}
                      </div>
                      <div style={{ minWidth: multiField.gapWidth.col1 }}></div>
                      <label className="title" style={col1TitleInlineStyle}>{`${row.col1.title2}:`}</label>
                      <div className="value" style={{ minWidth: multiField.valWidthOverride.col1 }}>
                        {row.col1.value2}
                      </div>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <label className="title" style={col1TitleInlineStyle}>{`${row.col1.title}:`}</label>
                      <div className="value">{row.col1.value}</div>
                    </Fragment>
                  )}
                </Fragment>
              )}
            </div>
            <div className="spacer"></div>
            <div className="report-header-property">
              <Fragment>
                <label className="title" style={col2TitleInlineStyle}>
                  {row.col2 ? `${row.col2.title}:` : ""}
                </label>
                <div className={`value ${row.col2 ? "" : "no-field"}`}>{row.col2 ? row.col2.value : ""}</div>
              </Fragment>
            </div>
            <div className="spacer"></div>
          </div>
        );
      })}
    </div>
  );
};

export default ReportInfoSection;



// WEBPACK FOOTER //
// ./src/libraries/ReportGenerator/ReportInfoSection.jsx